import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { HeaderContainer } from '../../header/headerContainer';
import { RightPanelControls } from '../../panels/rightPanelControls';
import { MttStagingDrawerControl } from './mttStagingDrawerControl';
import { MttStagingHeaderTitle } from './mttStagingHeaderTitle';
export const MttStagingHeaderBar = () => {
    return (_jsxs(HeaderContainer, { children: [_jsx(MttStagingDrawerControl, {}), _jsx(MttStagingHeaderTitle, {}), _jsx(RightPanelControls, {})] }));
};
